import apiClient from './apiClient';

export const login = async (username, password) => {
  try {
    const response = await apiClient.post('login/', { username, password });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Login failed');
  }
};

export const logout = async () => {
  try {
    await apiClient.post('logout/');
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Logout failed');
  }
};

export const updateProfile = async (payload) => {
  try {
    const response = await apiClient.post('profile/', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Profile update failed');
  }
};

export const listStaffUsers = async () => {
  try {
    const response = await apiClient.get('users-list/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Users load failed');
  }
};

export const listUsers = async (actorUserId) => {
  try {
    const response = await apiClient.get('users/', {
      params: { actor_user_id: actorUserId },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Users load failed');
  }
};

export const createUser = async (payload) => {
  try {
    const response = await apiClient.post('users/', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'User create failed');
  }
};

export const updateManagedUser = async (userId, payload) => {
  try {
    const response = await apiClient.put(`users/${userId}/`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'User update failed');
  }
};

export const deleteManagedUser = async (userId, actorUserId) => {
  try {
    const response = await apiClient.delete(`users/${userId}/`, {
      data: { actor_user_id: actorUserId },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'User delete failed');
  }
};
